import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Servico } from '../../../models/cadastro.model';
import { CadastroService } from '../../../services/cadastro.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalStateService } from '../../../services/modaState.service';

@Component({
  selector: 'app-servicos-modal',
  imports: [CommonModule, FormsModule],
  standalone: true,
  templateUrl: './servicos-modal.html',
  styleUrl: './servicos-modal.css'
})
export class ServicosModal implements OnInit {

  ngOnInit(): void {
    this.resetForm();
  }


  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();

  modalStateService = inject(ModalStateService);
  cadastroService = inject(CadastroService);
  selectedServico: Servico = this.getNewServico();
  
  termo: string = '';
  servicoPage: Servico[] | undefined;
  page = 0;
  size = 5;
  totalPages = 0;

  // Pagination
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  search() {

    this.cadastroService.getServicoSimplificado(this.termo).subscribe(response => {
      this.servicoPage = response;
      this.updatePageNumbers();
    });


  }

  selectServico(servico: Servico): void {
    this.selectedServico = servico;
  }

  inserirServico(): void {
    this.isOpen = false;
    this.modalStateService.close(this.selectedServico);
    this.closeModal.emit();
  }

  onPageChange(page: number) {
    this.setPage(page);
  }
  
  setPage(page: number): void {
    if (page < 0 || (this.servicoPage && page >= this.totalPages)) {
      return;
    }
    this.page = page;
    this.search();
  }

  updatePageNumbers(): void {
    if (!this.servicoPage) {
  
      return;
    }

    this.totalPages = this.servicoPage.length / this.size;
    const currentPage = this.page;
    const maxPages = this.maxPagesToShow;

    let startPage: number, endPage: number;

    if (this.totalPages <= maxPages) {
      startPage = 0;
      endPage = this.totalPages - 1;
    } else {
      const maxPagesBeforeCurrent = Math.floor(maxPages / 2);
      const maxPagesAfterCurrent = Math.ceil(maxPages / 2) - 1;

      if (currentPage <= maxPagesBeforeCurrent) {
        startPage = 0;
        endPage = maxPages - 1;
      } else if (currentPage + maxPagesAfterCurrent >= this.totalPages) {
        startPage = this.totalPages - maxPages;
        endPage = this.totalPages - 1;
      } else {
        startPage = currentPage - maxPagesBeforeCurrent;
        endPage = currentPage + maxPagesAfterCurrent;
      }
    }

    this.pages = Array.from(Array((endPage - startPage) + 1).keys()).map(i => startPage + i);
  }

  public onClose(): void {
    this.closeModal.emit(undefined);
  }

  public resetForm(): void {
    this.termo = '';
  }

  private getNewServico(): Servico {
    return {
      id: 0,
      nome: '',
      precoVenda: 0,
      descricao: ''
    };
  }
}
